import { Heading } from "@planningcenter/doxy-web"
import { PreferredEmailAddressSelector } from "./components/PreferredEmailAddressSelector"
import { SendsReceiptsSelector } from "./components/SendsReceiptsSelector"
import { css } from "@emotion/react"
import { useGivingPersonContext } from "../hooks/useGivingPersonContext"
import useNotifyNativeLoaded from "source/shared/hooks/useNotifyNativeLoaded"
import NativeHeader from "source/shared/NativeHeader"

export default function Notifications() {
  const { givingPerson } = useGivingPersonContext()

  useNotifyNativeLoaded()
  return (
    <>
      <NativeHeader title="Notifications" />
      <section>
        <div className="mb-2 d-n d-f@md">
          <Heading level={1} size={2} text="Notifications" />
        </div>
        <div
          className="p-2"
          css={css`
            border: 1px solid var(--color-tint6);
            border-radius: 8px;
          `}
        >
          <div className="d-f fd-c g-3">
            {givingPerson.email_addresses.length > 1 && (
              <PreferredEmailAddressSelector
                preferredEmailAddress={
                  givingPerson.giving_preferred_email_address
                }
                emailAddresses={givingPerson.email_addresses}
              />
            )}
            <SendsReceiptsSelector value={givingPerson.sends_receipts} />
          </div>
        </div>
      </section>
    </>
  )
}
